import {Component, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {Sort} from '@angular/material/sort';
import {TableControl} from '../../models/TableControl';
import {detailsExpand} from '../../animations';
import {SmsDTO} from '../../../pbm/models/sms/SmsDTO';
import {FormControl} from '@angular/forms';

enum TableColumns {
  Icons = 'icons',
  SmsId = 'smsId',
  IsSent = 'isSent',
  ToNumber = 'toNumber',
  Message = 'message',
  CommunicationTriggerType = 'communicationTriggerType',
  TriggerId = 'triggerId',
  SmsTemplate = 'smsTemplate',
}


@Component({
  selector: 'greydom-sms-table',
  templateUrl: './sms-table.component.html',
  styleUrls: [],
  animations: [detailsExpand]
})
export class SmsTableComponent {
  readonly tableColumns = TableColumns;

  @Input() smsDataSource: MatTableDataSource<SmsDTO>;
  @Input() smsTableControl: TableControl;
  @Input() smsDisplayedColumns: string[];
  @Input() dateTimeFormat: string;
  @Input() smsExpandedRow: SmsDTO | null;
  @Input() smsOverrideFormControl: FormControl<string>;

  @Output() sortData = new EventEmitter<Sort>();
  @Output() pageChanged = new EventEmitter<PageEvent>();
  @Output() rowClicked = new EventEmitter<{ event: MouseEvent, row: SmsDTO }>();
  @Output() sendSmsConfirmed = new EventEmitter<{ event: MouseEvent, row: SmsDTO }>();
  @Output() toggleIcons = new EventEmitter<{ event: MouseEvent, row: SmsDTO }>();
  @Output() editNumber = new EventEmitter<{ event: MouseEvent, row: SmsDTO }>();
  @Output() cancelEditNumber = new EventEmitter<{ event: MouseEvent, row: SmsDTO }>();
  @Output() saveNumber = new EventEmitter<{ event: MouseEvent, row: SmsDTO }>();
  @Output() duplicate = new EventEmitter<{ duplicate: boolean, row: SmsDTO }>();

  @ViewChild('smsPaginator', {static: false}) smsPaginator: MatPaginator;

  onSortData(event: Sort): void {
    this.sortData.emit(event);
  }

  onPageChanged(event: PageEvent): void {
    this.pageChanged.emit(event);
  }

  onRowClick(event: MouseEvent, row: SmsDTO): void {
    this.rowClicked.emit({event, row});
  }

  onClickSendSmsConfirmed(event: MouseEvent, row: SmsDTO): void {
    this.sendSmsConfirmed.emit({event, row});
  }

  onClickToggleIcons(event: MouseEvent, row: SmsDTO): void {
    this.toggleIcons.emit({event, row});
  }

  onClickEditNumber(event: MouseEvent, row: SmsDTO): void {
    this.editNumber.emit({event, row});
  }

  onClickCancelEditNumber(event: MouseEvent, row: SmsDTO): void {
    this.cancelEditNumber.emit({event, row});
  }

  onClickSaveNumber(event: MouseEvent, row: SmsDTO): void {
    this.saveNumber.emit({event, row});
  }

  onClickDuplicate(duplicate: boolean, row: SmsDTO): void {
    this.duplicate.emit({duplicate, row});
  }

  getToNumber(row: SmsDTO): string {
    return row.editedToNumber || row.toNumber;
  }
}
